import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Lehekülge ei leitud

  <span style="color:#85c1dc;">**FI:**</span>
  Sivua ei löytynyt

  <span style="color:#85c1dc;">**RU:**</span>
  Страница не найдена
*/
/* @__NO_SIDE_EFFECTS__ */
const m578 = msg(
  mf`Lehekülge ei leitud`,
  mf`Sivua ei löytynyt`,
  mf`Страница не найдена`,
)

export { m578 as 'errors.page.not-found.message' }